import axios from "axios";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { baseUrl } from "../helpers/baseUrl";

export async function signUp(userData) {
  try {
    const response = await axios.post(`${baseUrl}/user/sign-up`, userData);
    // Swal.fire("", response.data.message, "success");
    toast.success(`Account registered,${response.data.message}`, {
      style: {
        fontSize: "15px",
      },
    });
    return response;
  } catch (err) {
    console.log("err", err.response);
    if (err.response.status === 500) {
      // Swal.fire("Server issue", "Please try again later", "error");
      toast.error(`Server issue, please try again later`, {
        style: {
          fontSize: "15px",
        },
      });
    } else if (err.response.status === 400) {
      // Swal.fire(`${err.response.data.error}`, "", "error");
      toast.warning(`${err.response.data.error}`, {
        style: {
          fontSize: "15px",
        },
      });
    } else {
      // Swal.fire("Something went wrong", "Please try again later", "error");
      toast.error(`Something went wrong, please try again later`, {
        style: {
          fontSize: "15px",
        },
      });
    }
    // return err;
  }
}

export async function signIn(userData) {
  try {
    const res = await axios.post(`${baseUrl}/user/login`, userData);
    const { Token, username } = res.data;

    localStorage.setItem("jwtTokenSingh", Token);
    localStorage.setItem("userNameSingh", username);
    //Set token on Header request
    // setAuthToken(token);
    // const decodedUser = jwt_decode(token);
    // console.log("decode use", decodedUser);
    return res;
  } catch (err) {
    console.log("err", err.response);

    if (err.response.status === 400) {
      // Swal.fire(`${err.response.data.error}`, ``, `error`);
      toast.warning(`Incorrect password`, {
        style: {
          fontSize: "15px",
        },
      });
    } else if (err.response.status === 404) {
      // Swal.fire(`${err.response.data.error}`, ``, `error`);
      toast.warning(`Email Id is not registered`, {
        style: {
          fontSize: "15px",
        },
      });
    } else if (err.response.status === 405) {
      // Swal.fire(`${err.response.data.error}`, ``, `error`);
      toast.warning(`${err.response.data.google}`, {
        style: {
          fontSize: "15px",
        },
      });
    } else if (err.response.status === 410) {
      // Swal.fire(``, `${err.response.data.activate}`, `warning`);
      toast.warning(`${err.response.data.activate}`, {
        style: {
          fontSize: "13px",
        },
      });
    } else {
      // Swal.fire("Server issue", "Please try later", "error");
      toast.error(`Oops! something went wrong, please try again later`, {
        style: {
          fontSize: "15px",
        },
      });
    }
    return err.response;
  }
}

export async function googleSignIn(googleData) {
  try {
    // const res = await axios.post(`${baseUrl}/user/google/login`, googleData);
    const res = await axios.post(`${baseUrl}/user/google/weblogin`, googleData);
    const { Token, username } = res.data;

    localStorage.setItem("jwtTokenSingh", Token);
    localStorage.setItem("userNameSingh", username);
    //Set token on Header request
    // setAuthToken(token);
    // const decodedUser = jwt_decode(token);
    // console.log("decode use", decodedUser);
    return res;
  } catch (err) {
    console.log("err", err.response);

    if (err.response.status === 400) {
      // Swal.fire(`${err.response.data.error}`, ``, `error`);
      toast.warning(`Incorrect password`, {
        style: {
          fontSize: "15px",
        },
      });
    } else if (err.response.status === 404) {
      // Swal.fire(`${err.response.data.error}`, ``, `error`);
      toast.warning(`Email Id is not registered`, {
        style: {
          fontSize: "15px",
        },
      });
    } else if (err.response.status === 410) {
      // Swal.fire(``, `${err.response.data.activate}`, `warning`);
      toast.warning(`${err.response.data.activate}`, {
        style: {
          fontSize: "13px",
        },
      });
    } else {
      // Swal.fire("Server issue", "Please try later", "error");
      toast.error(`Server issue, Please try again later`, {
        style: {
          fontSize: "15px",
        },
      });
    }
    return err.response;
  }
}

export async function forgotPassword(emailId) {
  // var tokenStr = localStorage.getItem("jwtTokenSingh");
  // axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.get(
      `${baseUrl}/user/forget-password/${emailId}`
    );
    // console.log("forgotPassword", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    if (err.response.status === 404) {
      // Swal.fire(`${err.response.data.error}`, ``, `error`);
      toast.error(`${err.response.data.error}`, {
        style: {
          fontSize: "15px",
        },
      });
    } else {
      // Swal.fire("Server issue", "Please try later", "error");
      toast.error(`Server issue`, {
        style: {
          fontSize: "15px",
        },
      });
    }
    return err;
  }
}

export async function validateOtp(validationData) {
  // var tokenStr = localStorage.getItem("jwtTokenSingh");
  // axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(
      `${baseUrl}/user/validate-otp`,
      validationData
    );
    // console.log("validateOtp", response);
    return response;
  } catch (err) {
    console.log("err", err.response);
    if (err.response.status === 400) {
      Swal.fire(`${err.response.data.error}`, ``, `error`);
    } else {
      Swal.fire("Server issue", "Please try later", "error");
    }
    return err;
  }
}

export async function resetPassword(passwordData) {
  // var tokenStr = localStorage.getItem("jwtTokenSingh");
  // axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(
      `${baseUrl}/user/reset-password`,
      passwordData
    );
    // console.log("resetPassword", response);

    if (response.status === 200) {
      toast.success(`Password changed`, {
        style: {
          fontSize: "15px",
        },
      });
    }
    return response;
  } catch (err) {
    console.log("err", err.response);
    // Swal.fire("Oops! Something went wrong", "Please try later", "error");
    toast.error(`Oops! Something went wrong, please try later`, {
      style: {
        fontSize: "15px",
      },
    });

    return err.response;
  }
}

export async function logout(firebaseToken) {
  // var tokenStr = localStorage.getItem("jwtTokenSingh");
  // axios.defaults.headers.common["authorization"] = tokenStr;
  try {
    const response = await axios.post(`${baseUrl}/logout`, firebaseToken);
    // console.log("logout", response);
    // return response;
  } catch (err) {
    console.log("err", err.response);
    // return err.response;
  }
}
